import { useAuthStore } from '@/stores/auth.store'

function matchPermission(pattern: string, target: string): boolean {
  if (pattern === '*:*') return true
  const [pp = '', pa = ''] = pattern.split(':')
  const [tp = '', ta = ''] = target.split(':')
  return (pp === '*' || pp === tp) && (pa === '*' || pa === ta)
}

export function hasPermission(userPerms: readonly string[], required: string): boolean {
  return userPerms.some((p) => matchPermission(p, required))
}

export function usePermission(required: string): boolean {
  const permissions = useAuthStore((s) => s.permissions)
  return hasPermission(permissions, required)
}
